module.exports = __webpack_public_path__ + "static/media/calendar.5abf3376.svg";